export const RACEX_TOKEN_ADDRESS = '0x7086e045b78E1e72F741F25231c08d238812CF8a'
export const ROADMAP_STATUS = {
    DONE: 'done',
    RUNNING: 'running',
    WORKING: 'working'
}
export const MyNFTPageTabs = {
    nfKeys: 'My NFKeys',
    cars: 'My Cars'
}
export const TWITTER_LINK = 'https://twitter.com/DcrcAvax'
export const TELEGRAM_LINK = 'https://t.me/DCRCRACEX'
export const DISCORD_LINK = 'https://t.co/CnCpyH0XRR'
export const MEDIUM_LINK = 'https://medium.com/dcrcracex'
export const GITBOOK_LINK = 'https://dcrc.gitbook.io/dcrc.racing/'
export const WINDOWS_LINK = 'https://www.datamagic.co.za/racex'
export const MAC_LINK = 'https://drive.google.com/file/d/1-_m3uyZkaWIHaM2pAG9Yn9D5EkJTTH1n/view?usp=sharing'
export const BUY_LINK = 'https://dex.guru/token/0x7086e045b78e1e72f741f25231c08d238812cf8a-avalanche'

// MainNet Address
export const ADDRESS_RACEX = '0x7086e045b78e1e72f741f25231c08d238812cf8a'
export const ADDRESS_RACEXNFKEY = '0x4752ecaf18bf9153256a632340fc4dec511eab71'
export const ADDRESS_RACEXCARNFT = '0x3C1CD2C9052877512e1Ed504F7f9C4b4BB5F3Beb'
export const ADDRESS_RACEXREFLECT = '0xACcCE5Ba3708703704Fb27d82162B66F6828214b'

// TestNet Address
// export const ADDRESS_RACEX = '0xE3D50A7EDfE38533af6fEE99905A15e33491B6D7'
// export const ADDRESS_RACEXNFKEY = '0x7b15875a0d04387b8e71072003ba728a9f933c4e'
// export const ADDRESS_RACEXCARNFT = '0x70461eDf194283bB7E941E55744ebB141A6a2890'
// export const ADDRESS_RACEXREFLECT = '0xe7f0c81Ea2457a92B4c412F5668fed6a42D6A3ec'

export const KALAO_LINK = 'https://marketplace.kalao.io/collection/0x3c1cd2c9052877512e1ed504f7f9c4b4bb5f3beb'
export const NFTRADE_LINK = 'https://nftrade.com/assets/avalanche/0x3c1cd2c9052877512e1ed504f7f9c4b4bb5f3beb'
export const PUBLIC_SALE_PRICE = {
    1: 0,
    2: 3,
    3: 3.5,
    4: 4
}